export default "__VITE_ASSET__dKTk7Wie__"